import { render } from "./slide-2.vue?vue&type=template&id=4625d0f1&scoped=true"
import script from "./slide-2.vue?vue&type=script&lang=js"
export * from "./slide-2.vue?vue&type=script&lang=js"

import "./slide-2.vue?vue&type=style&index=0&id=4625d0f1&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4625d0f1"]])

export default __exports__